import { Component, OnInit, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { IError } from 'app/_models/IError';
import { ITranslationsClass } from '../_models/ITranslationsClass'
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'error-component',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  darkMode: boolean = false;  
  errorDetails: IError;

  constructor(    
    public translations: ITranslationsClass,    
    public clipboard: ClipboardService,
    private location: Location
  ) {
    if (localStorage.getItem('qx_setting_darkMode')) this.darkMode = true;

    if(sessionStorage.getItem('errorDetails')) {            
      this.errorDetails = JSON.parse(sessionStorage.getItem('errorDetails'));      
      sessionStorage.removeItem('errorDetails');
      console.log(this.errorDetails);            
    }
  }

  ngOnInit(): void { 
    window.addEventListener('popstate', this.handlePopState); 
  }

  ngOnDestroy(): void { 
    window.removeEventListener('popstate', this.handlePopState); 
  }
  
  @HostListener('window:popstate', ['$event'])
  onPopState(event): void { 
    this.location.forward(); 
  }
        
  copy(text: string): void { 
    this.clipboard.copy(text); 
  }

  logout(): void {
    sessionStorage.clear();    
    localStorage.removeItem('qx_userId');
    localStorage.removeItem('qx_username');
    window.location.href = '/signin';
  }  

  handlePopState(): void { }
}
